import { c as _c } from "react/compiler-runtime";
import { CardItem } from "@/components/ui/Card";
import { Skeleton } from "@/components/ui/Skeleton";

/** Reserves the same label/value rows as a loaded profile card. */
export function ProfileSectionSkeleton(t0) {
  const $ = _c(8);
  const {
    label,
    rows: t1
  } = t0;
  const rows = t1 === undefined ? 3 : t1;
  let t2;
  if ($[0] !== label) {
    t2 = <span className="sr-only">{label}</span>;
    $[0] = label;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== rows) {
    t3 = <div aria-hidden="true">{Array.from({
        length: rows
      }, _temp)}</div>;
    $[2] = rows;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== label || $[5] !== t2 || $[6] !== t3) {
    t4 = <div role="status" aria-label={label}>{t2}{t3}</div>;
    $[4] = label;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(_, index) {
  return <CardItem key={index}><Skeleton size="xs" className="w-2/5" /><Skeleton size="xs" className="w-1/4" /></CardItem>;
}